<!--
Author: TangChen
Date: 2018-11-23
Desc: 热门基金
 -->
<template>
    <div v-show="fund.length>0" :class="'view-hot-fund view ' + (fund.length<4?className:'')">
        <comp-title v-if="fund.length<4" :title="title" />
        <hot-tab v-if="fund.length>3" :fund-info="fund" v-on:fund-continue="fundBuy" />
        <fund-list v-else :fund-info="fund" :is-hot="true" v-on:fund-continue="fundBuy" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import hotTab from "@/components/fund/hotTab";
import fundList from "@/components/fund/fundList";
export default {
    name: "HotFund",
    components: {
        hotTab,
        fundList
    },
    mixins: [mixin],
    data () {
        return {
            fund: [],
            allFund: [],
            user: {}
        };
    },
    watch: {
        "$store.state.user.qryallfund"(val){
            this.getFund(val);
        }
    },
    created () {
        this.user = this.$cache.getUser();
        this.getHotFund();
    },
    methods: {
        getHotFund () {
            const _this = this;
            this.$util.request("trade/fund/recommended").then(res => {
                if (res.data) {
                    _this.allFund = res.data;
                    _this.getFund(this.user.qryallfund || "");
                }
            });
        },
        getFund(val){
            if(val === "0"){
                const _this = this;
                this.fund = this.allFund.filter(item=>{
                    return item.risklevel <= _this.user.custrisk;
                });
            }else{
                this.fund = this.allFund;
            }
        },
        fundBuy (way, val) {
            let _url = "";
            if (way === "20,22") {
                _url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                _url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, res => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way });
                    sessionStorage.setItem(_url, JSON.stringify(_x));
                    this.$router.push({ name: _url, query: { fundcode: _x.fundcode } });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.view-hot-fund {
    overflow: hidden;
    /*卡片效果*/
    .comp-fund-list {
        padding: 10px 20px;
        .el-table--fit {
            margin: 0;
        }
    }
}
</style>
